import { IApplicationState } from '../../types/redux';

export const isAutorisationPopupOpenSelector = (state: IApplicationState) =>
  state.consultantCianChat.isAutorisationPopupOpened;
